import imgPresentationSession from "../../../../assets/images/IMAGEM-HEADER-OBSERVATÓRIO.svg";

export const dados = {
  primary: true,
  headline:
    "Observatório da saúde do(a) trabalhador(a) da saúde no contexto da covid-19",
  description:
    "Acompanhe como a pandemia afeta condições de trabalho, saúde e segurança do(a) " +
    " trabalhador(a), em especial de profissionais do SUS com atuação no Nordeste.",
  imgStart: "",
  img: imgPresentationSession,
  alt: "",
  start: "",
};
